import React from 'react';
import { journeySteps } from '../data/breakFreeContent';
type JourneyStripProps = {
  className?: string;
};
export function JourneyStrip({
  className = ''
}: JourneyStripProps) {
  return <ol className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:gap-x-4 ${className}`} aria-label="The six stages of the BREAK FREE journey" data-id="element-111" data-mp="2ysmgqrsjz9en">
      {journeySteps.map((step, i) => <li key={step} className="flex items-center gap-3 sm:gap-4" data-id="element-112" data-mp="263fd5ee8rtmj" data-mpi={i}>
          <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-ivory-200 sm:text-[11px]" data-id="element-113" data-mp="215drclpflg7d">
            <span className="mr-1.5 font-sans text-champagne" data-id="element-114" data-mp="2f5ete4hfmtof">{i + 1}</span>
            {step}
          </span>
          {i < journeySteps.length - 1 && <span className="text-champagne/40" aria-hidden="true" data-id="element-115" data-mp="2b5edsgilkcfs">
              →
            </span>}
        </li>)}
    </ol>;
}